const Images = {
    tiim: {
        logo: require('../images/logo.png'),
        logoTiim: require('../images/logoTiim.png'),
        stores: require('../images/stores.png'),
        howWeDoIt: require('../images/howWeDoIt.png'),
        howWeDoIt2: require('../images/howWeDoIt2.png'),
        school: require('../images/school.png'),
        school2: require('../images/school2.png'),
        academy: require('../images/academy.png'),
        academy2: require('../images/academy2.png'),
        club: require('../images/club.png'),
        club2: require('../images/club2.png'),
        club3: require('../images/club3.png'),
        payment: require('../images/payment.png'),
        bank: require('../images/bank.png'),
        family: require('../images/family.png'),
        family2: require('../images/family2.png'),
        security: require('../images/security.png'),
        reviews: require('../images/reviews.png'),
    },
    verticals: {
        collages: require('../images/verticals/collages.png'),
        academies: require('../images/verticals/academies.png'),
        clubs: require('../images/verticals/clubs.png'),
        family: require('../images/verticals/family.png'),
    },
    clients: {
        williams: require('../images/clients/williams.png'),
        irish: require('../images/clients/irish.png'),
        aim: require('../images/clients/aim.png'),
        libanes: require('../images/clients/libanes.png'),
        kudos: require('../images/clients/kudos.png'),
        bosques: require('../images/clients/bosques.png'),
    },
    icons: {
        menu: require('../images/menu.png'),
        circleCheck2: require('../images/icons/circleCheck2.png'),
        arrowRight: require('../images/icons/arrowRight.png'),
    },
    suscription:{
        checka: require('../images/suscription/checka.webp'),
    },
    academy: {
        ballet: require('../images/academy/ballet.png'),
        config: require('../images/academy/config.png'),
        introDesktop: require('../images/academy/intro_desktop.png'),
        introMobile: require('../images/academy/intro_mobile.png'),
        platform: require('../images/academy/platform.png'),
        price: require('../images/academy/price.png'),
        clients: {
            bloomberg: require('../images/academy/clients/bloomberg.png'),
            entrepreneur: require('../images/academy/clients/entrepreneur.png'),
            expansion: require('../images/academy/clients/expansion.png'),
            financiero: require('../images/academy/clients/financiero.png'),
            forbes: require('../images/academy/clients/forbes.png'),
            milenio: require('../images/academy/clients/milenio.png'),
            techcrunch: require('../images/academy/clients/techcrunch.png'),
        },
        modules: {
            app: require('../images/academy/modules/app.png'),
            assitance: require('../images/academy/modules/assitance.png'),
            calendar: require('../images/academy/modules/calendar.png'),
            chat: require('../images/academy/modules/chat.png'),
            documents: require('../images/academy/modules/documents.png'),
            evaluations: require('../images/academy/modules/evaluations.png'),
            events: require('../images/academy/modules/events.png'),
            message: require('../images/academy/modules/message.png'),
            payments: require('../images/academy/modules/payments.png'),
            photos: require('../images/academy/modules/photos.png'),
            shop: require('../images/academy/modules/shop.png'),
            tournaments: require('../images/academy/modules/tournaments.png'),
        },
        users: {
            admin: require('../images/academy/users/admin.png'),
            coach: require('../images/academy/users/coach.png'),
            parent: require('../images/academy/users/parent.png'),
            student: require('../images/academy/users/student.png'),
        },
    }
};

export default Images;